import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SX_renderpage_tick } from "../../assets/icons";

const styles = {
  fontFamily: "Manrope",
  fontWeight: "500",
  fontStyle: "normal",
  textDecoration: "none",
};
const lableStyles = {
  fontFamily: "Manrope",
  fontWeight: "800",
  fontStyle: "normal",
  textDecoration: "none",
};
const currentPlanStyles = {
  fontWeight: "600",
  fontStyle: "normal",
  textDecoration: "none",
};
const upgrdBtnStyle = {
  backgroundColor: "var(--shadePurple100)",
  color: "white",
  borderRadius: ".5rem",
  padding: "4px 22px",
  outline: "1px solid var( --white-20)",
};
const CancelBtnStyle = {
  backgroundColor: "var(--ShadeGray800)",
  color: "white",
  borderRadius: ".5rem",
  padding: "4px 22px",
  outline: "1px solid var( --white-20)",
  cursor: "default",
};

const CurrentPlan = ({
  lable,
  buttonLable,
  iscurrentPlanActivate,
  rendersLimit,
  projectLimits,
  onClick,
  subscription_status,
  setIsPlanShow,
}) => {
  // console.log('Render Page CurrentPlan');

  const { isPageOptionSelected } = useSelector((state) => state.commonReducer);
  // console.log('CurrentPlan isPageOptionSelected = ',isPageOptionSelected);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { projectId } = useParams();
  // console.log('CurrentPlan projectId = ',projectId, isPlanShow);

  const location = useLocation();
  // console.log('RenderPlan Current Plan', location);
  const pathSegments = location.pathname.split("/");
  const segment = pathSegments[2];
  // console.log('segment = ',segment);

  const navigateHandler = () => {
    if (subscription_status === 1) {
      if (segment === "card") {
        navigate("/more_info", {
          state: {
            isRender: true,
            isMoreInfo: false,
            isCard: true,
            projectId: projectId,
          },
        });
      } else {
        navigate("/more_info", {
          state: {
            isRender: true,
            isMoreInfo: false,
            isCard: false,
            projectId: projectId,
          },
        });
      }
    } else {
      if (segment === "card") {
        navigate("/user-plans", {
          state: {
            isRender: true,
            isMoreInfo: false,
            isCard: true,
            projectId: projectId,
          },
        });
        setIsPlanShow(true);
      } else {
        navigate("/user-plans", {
          state: {
            isRender: true,
            isMoreInfo: false,
            isCard: false,
            projectId: projectId,
          },
        });
        setIsPlanShow(true);
      }
    }
  };

  return (
    <div
      className="h-full w-[45%] flex py-[15px] px-[25px]  flex-col SubBox1 "
      style={{
        border: "1px solid #ffffffcc",
        borderRadius: "1rem",
        color: "#f8f8f6",
      }}
    >
      <div className="w-full  h-[100px] pl-[.25rem]  pr-[10px] flex flex-col justify-evenly">
        <div className="flex items-center">
          <p
            className="lg:text-[1.3rem] text-[0.9rem] mt-[-3px]"
            style={lableStyles}
          >
            {lable}
          </p>
        </div>

        <div className="">
          <p
            className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
            style={styles}
          >
            {rendersLimit}
          </p>
          <p
            className="sm:leading-[1.125rem] priceCubetext tracking-wide text-[14px]"
            style={styles}
          >
            {projectLimits}
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-2 h-[40px]">
        <div className="flex items-start p-1 ">
          <button
            className="upgrad_btn manrope-800 sm:text-base flex items-center justify-center px-[12px] py-[4px] bg-[#4e4e4e] "
            style={CancelBtnStyle}
          >
            <img className="w-4 h-full mr-2" src={SX_renderpage_tick} alt="" />
            Current
          </button>
        </div>

        {buttonLable && (
          <div className="flex items-start p-1 ">
            {iscurrentPlanActivate ? (
              <button
                className=" manrope-800 upgrad_btn  sm:text-base  px-[22px] py-[4px]"
                type="submit"
                onClick={navigateHandler}
                style={upgrdBtnStyle}
              >
                {buttonLable}
              </button>
            ) : (
              <button
                className=" manrope-800 upgrad_btn  sm:text-base  px-[22px] py-[4px]"
                type="submit"
                onClick={
                  subscription_status === 2 ? navigateHandler : navigateHandler
                }
                style={upgrdBtnStyle}
              >
                {buttonLable}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrentPlan;
